import Vue from 'vue'
import Vuex from 'vuex';
import axios from 'axios';
import router from './router';

const jwtKey = "jwt";

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        user: undefined,
        jwt: undefined,
        remember: false,
        menuItems: [],
        show_consenso_webtracking: false,
        show_consenso_pod: false,
        show_change_password: false,
        show_dhl_tracking_link: false,
        loggingOut: false
    },
    getters: {
        uri(state) {
            if(state.user) return "/"+state.user.role;
            else router.replace('/login');
        }
    },
    mutations: {
        show_consenso_webtracking(state, flag) {
            state.show_consenso_webtracking = flag;
        },
        show_consenso_pod(state, flag) {
            state.show_consenso_pod = flag;
        },
        show_change_password(state, flag) {
            state.show_change_password = flag;
        },
        show_dhl_tracking_link(state, flag) {
            state.show_dhl_tracking_link = flag;
        },
        setHeader(state) {
            axios.defaults.headers['Authorization'] = 'Bearer ' + state.jwt;
        },
        async login(state, jwt) {
            // Si controlla PRIMA di salvare: un token deve essere una stringa in tre
            // pezzi separati dal punto. Prima entrava qualunque cosa arrivasse dal
            // server, e se non era un token nel localStorage finiva "[object Object]":
            // da li' in poi parseJwt lanciava a ogni chiamata e il sito smetteva di
            // rispondere senza dire niente.
            if (typeof jwt !== 'string' || jwt.split('.').length !== 3) {
                console.log('token non valido, non lo salvo');
                return;
            }
            state.jwt = jwt;
            localStorage.setItem(jwtKey, jwt);
            this.commit('loadUser');
            this.commit('show_consenso_webtracking', !state.user.consenso_webtracking);
            this.commit('show_dhl_tracking_link', state.user.show_dhl_tracking_link);
        },
        async logout(state) {
            state.loggingOut = true;
            localStorage.removeItem(jwtKey);
            state.jwt = undefined;
            state.user = undefined;
            // 05/10/2026: si toglie anche l'intestazione che setHeader aveva messo su
            // axios. Prima restava "Bearer <token vecchio>" e le chiamate dopo il
            // logout partivano ancora autenticate. Con JWT_BLACKLIST_GRACE_PERIOD=60
            // il server accetta quel token per altri 60 secondi: /menuitems
            // rispondeva 200, il router non trovava /login fra le voci e mandava
            // alla dashboard invece che al login.
            delete axios.defaults.headers['Authorization'];
            state.show_consenso_webtracking = false;
            state.show_consenso_pod = false;
            state.show_change_password = false;
            state.show_dhl_tracking_link = false;
            state.loggingOut = false;
        },

        getUser(state) {
            state.jwt = localStorage.getItem(jwtKey);
            this.commit('loadUser');
        },

        loadUser(state) {
            if (state.jwt) {
                // Un token illeggibile o senza il claim 'user' non deve far saltare
                // tutto: si esce come se non si fosse loggati, e il giro normale
                // (401 -> login) fa il suo lavoro.
                let body = null;
                try {
                    body = parseJwt(state.jwt);
                } catch (e) {
                    console.log('token illeggibile:', e && e.message);
                }
                if (!body || typeof body.user === 'undefined') {
                    state.jwt = undefined;
                    state.user = undefined;
                    localStorage.removeItem(jwtKey);
                    return;
                }
                state.user = JSON.parse(body.user);



                state.remember = body.remember;
                this.commit('refreshUser');
                this.commit('initMenuItems');
            }
        },
        async refreshUser(state) {
            state.user = (await axios.get('/auth/user')).data;
            this.commit('show_dhl_tracking_link', state.user.show_dhl_tracking_link);
        },
        async initMenuItems(state) {
            this.commit('setHeader');
            let res = await axios.get("/menuitems");
            if(res.data) Vue.set(state, 'menuItems', res.data);
        },
    },
    actions: {
        async refresh({commit, state}) {
            try {
                let res = await axios.get('/auth/refresh');
                // il token puo' arrivare nudo o dentro un oggetto, a seconda di come
                // il log delle API incarta la risposta: si accettano tutti e due
                const dati = res ? res.data : null;
                const jwt = typeof dati === 'string' ? dati : (dati && dati.jwt);
                commit('login', jwt);
                // 'login' rifiuta quello che non e' un token: se lo stato non e'
                // cambiato il rinnovo NON e' riuscito, e va detto a chi ha chiamato.
                // Prima si restituiva true comunque, e chi chiamava riprovava la
                // chiamata con il token vecchio.
                if (state.jwt !== jwt) {
                    return false;
                }
                commit('initMenuItems');
                return true;
            } catch(e) {
                return false;
            }
        }
    },
});

function parseJwt(jwt) {
    var base64Url = jwt.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
        atob(base64)
            .split("")
            .map(function(c) {
                return (
                    "%" +
                    ("00" + c.charCodeAt(0).toString(16)).slice(-2)
                );
            })
            .join("")
    );
    return JSON.parse(jsonPayload);
}

export default store;
